import vmClient from 'app/services/vmClient';
import { TranslationsForEntity, ALL_TRANSLATIONS } from 'app/constants/schemas/translations';
import { Offset, OffsetMarshaller } from 'app/constants/schemas/Offset';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';
import { DateMarshaller } from 'app/constants/schemas/Date';

export interface IWordSentenceOffsets extends IEntity {
  attributes: {
    id: EntityStringId;
    wordOffsets: Offset[];
    /* This Offset[] | null actually encodes a more complex relationship than might be immediately apparent.
     * If the transliterationOffsets are `null`, it means that no offsets should ever be set for
     * the word sentence. If the word/sentence language do not prefer transliterations, then this
     * would be set to null. Conversely, if the word/sentence do prefer transliteration, this should
     * never be null. The absence of a transliteration in that situation would be represented by
     * an empty list.
     */
    transliterationOffsets: Offset[] | null;
    readonly createdAt: Date;
    readonly updatedAt: Date;
  };
}

export type WordSentenceOffsets = Entity<IWordSentenceOffsets>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WordSentenceOffsets: IEntityType<IWordSentenceOffsets> = vmClient.defineClass({
  typeName: 'WordSentenceOffsets',
  version: 2,
  lockable: true,
  persisted: true,
  attributes: {
    wordOffsets: {
      collection: true,
      type: Offset,
      marshaller: OffsetMarshaller,
      notNull: true,
    },
    transliterationOffsets: {
      collection: true,
      type: Offset,
      marshaller: OffsetMarshaller,
    },
    createdAt: {
      type: Date,
      marshaller: DateMarshaller,
      notNull: true,
    },
    updatedAt: {
      type: Date,
      marshaller: DateMarshaller,
      notNull: true,
    },
  },
});

export const WordSentenceOffsetsTranslations: Partial<TranslationsForEntity<IWordSentenceOffsets>> = {
  wordOffsets: {
    getLabel: (t) => t('entity-fields.WordSentenceOffsets.wordOffsets.label'),
  },
  transliterationOffsets: {
    getLabel: (t) => t('entity-fields.WordSentenceOffsets.transliterationOffsets.label'),
  },
};

ALL_TRANSLATIONS.set(WordSentenceOffsets, WordSentenceOffsetsTranslations);
